export default __webpack_public_path__ + "static/media/banner1.f8d6d1ce.jpg";